// AUTO-GENERATED from features.yaml by app.core.features.codegen. DO NOT EDIT.
// Regenerate (from backend/): uv run python -m app.core.features.codegen

export const Feature = {
  AGENTS: 'agents',
  ANALYTICS: 'analytics',
  INTERNAL_SEARCH: 'internal_search',
  KNOWLEDGE_TOGGLE: 'knowledge_toggle',
  INTERNET_SEARCH: 'internet_search',
  DOCUMENT_UPLOAD: 'document_upload',
  IMAGE_INSPECTION: 'image_inspection',
  AGENT_FLAG_SCOPE: 'agent_flag_scope',
  MODEL_SELECTION: 'model_selection',
} as const

export type FeatureId = (typeof Feature)[keyof typeof Feature]

export const FEATURE_IDS: readonly FeatureId[] = Object.values(Feature)

/** Catalog defaults: what a fresh deployment is seeded with; the offline fallback. */
export const FEATURE_DEFAULTS: Record<FeatureId, boolean> = {
  'agents': false,
  'analytics': true,
  'internal_search': false,
  'knowledge_toggle': false,
  'internet_search': false,
  'document_upload': false,
  'image_inspection': false,
  'agent_flag_scope': false,
  'model_selection': false,
}

/** Admin-page segmentation: group id -> label, in catalog order. */
export const FEATURE_GROUPS = {
  chat: 'Chat & tools',
  knowledge: 'Knowledge',
  agents: 'Agents',
  admin: 'Administration',
} as const

export type FeatureGroupId = keyof typeof FEATURE_GROUPS

export const FEATURE_GROUP_OF: Record<FeatureId, FeatureGroupId> = {
  'agents': 'agents',
  'analytics': 'admin',
  'internal_search': 'knowledge',
  'knowledge_toggle': 'knowledge',
  'internet_search': 'chat',
  'document_upload': 'chat',
  'image_inspection': 'chat',
  'agent_flag_scope': 'agents',
  'model_selection': 'chat',
}
